import * as React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import LineUpCard from "./line-up-card";

const artists = [
  {
    name: "ANNA ERHARD",
    sort: "ANNA ERHARD",
    link: "https://www.annaerhard.com/",
    img: "anna-erhard-pressefotos.jpg",
  },
  {
    name: "BUBBLE TEA AND CIGARETTES",
    sort: "BUBBLE TEA AND CIGARETTES",
    link: "https://open.spotify.com/artist/2UMeX51X1prCFgi51RHo9P?si=kHyT5YgfQR61YTz0WeOg5w",
    img: "bubble-tea.jpg",
  },
  {
    name: "CROCODILES",
    sort: "CROCODILES",
    link: "https://open.spotify.com/artist/1Z4Erxt5wSXH0gbOsVJUMv?si=A7ZlfIepRFSTX2KDlzxO5A",
    img: "crocodiles.jpg",
  },
  {
    name: "DEADLETTER",
    sort: "DEADLETTER",
    link: "http://www.deadletter.co.uk/",
    img: "deadletter.jpg",
  },
  {
    name: "FUZZ LIGHTYEAR",
    sort: "FUZZ LIGHTYEAR",
    link: "https://open.spotify.com/artist/24Eklv4Dvhk1c6iXuCFzoL?si=--d91T_TSsaPBp-bPGfI9g",
    img: "fuzz-lightyear.jpg",
  },
  {
    name: "GEORGE CLANTON",
    sort: "GEORGE CLANTON",
    link: "https://open.spotify.com/artist/1G5v3lpMz7TeoW0yGpRQHr?si=U0gfkkc3TgigPKBFsO-cqA",
    img: "george-clanton.jpg",
  },
  {
    name: "GOAT",
    sort: "GOAT",
    link: "https://open.spotify.com/artist/6jP9Z7o6WlbYvKUOeO5SbP?si=CBe6JOJZQHuzodKGGp_KIQ",
    img: "goat.jpg",
  },
  {
    name: "GOBLYNS",
    sort: "GOBLYNS",
    link: "https://open.spotify.com/artist/4FKI84FE62a5BxfrKtB1HF?si=EdDpRm_XSSaXeJhFAGHEmA",
    img: "goblyns.jpg",
  },
  {
    name: "HELICON",
    sort: "HELICON",
    link: "https://www.heliconglasgow.com/",
    img: "helicon.jpg",
  },
  {
    name: "HONEYGLAZE",
    sort: "HONEYGLAZE",
    link: "https://open.spotify.com/artist/0IJZjR1tj2EudGR8jvxZtM?si=Z7laW59tQ2SazKvEhEE9og",
    img: "honey-glaze.jpg",
  },
  {
    name: "MOJO & THE KITCHEN BROTHERS",
    sort: "MOJO & THE KITCHEN BROTHERS",
    link: "https://open.spotify.com/artist/0uK9AvSTGcy7LKeEGjVvl4?si=El1lYm5kQyCjZFcPI_sVVA",
    img: "mojo.jpeg",
  },
  {
    name: "KIT SEBASTIAN",
    sort: "KIT SEBASTIAN",
    link: "https://kitsebastian.com/",
    img: "kit-seb.jpg",
  },
  {
    name: "PINS Playing Wild Nights",
    sort: "PINS Playing Wild Nights",
    link: "https://open.spotify.com/album/4289lORqLU7Ih7eZFFBZyE?si=pvPZ62NwRZmEoewXinxfxA",
    img: "pins.jpg",
  },
  {
    name: "YASMIN COE",
    sort: "YASMIN COE",
    link: "https://open.spotify.com/artist/0j4GgXioTvigdt9HuQCrAl?si=Z3rJgej5SrePbpdViYumnw",
    img: "yasmin-coe.jpg",
  },
  {
    name: "YUUF",
    sort: "YUUF",
    link: "https://open.spotify.com/artist/3VfdXeAhqukWy1TTimSA7v?si=R0HEpN2vReugiad6ExyDlw",
    img: "yuff.jpg",
  },
  {
    name: "Adore",
    sort: "Adore",
    link: "https://open.spotify.com/artist/4BwY0FjNdkoWef8kixy54M?si=z9HrABpeTs6Wko945Lkwbg",
    img: "adore.jpeg",
  },
  {
    name: "Adult DVD",
    sort: "Adult DVD",
    link: "https://open.spotify.com/artist/1lT3vDbjqz299SxePec6ZG?si=rIS8WaSRSeuDu8PVgDRqIA",
    img: "adultdvd.jpg",
  },
  {
    name: "BLIND YEO",
    sort: "BLIND YEO",
    link: "https://open.spotify.com/artist/5wf9NEx8BtntEd3HiqLNjd?si=zrv0Gj-ETfW9abFzPU7Qfw",
    img: "blindyeo.jpg",
  },
  {
    name: "CHASTITY BELT",
    sort: "CHASTITY BELT",
    link: "https://www.chastitybeltmusic.com/",
    img: "chasbelt.jpg",
  },
  {
    name: "DEARY",
    sort: "DEARY",
    link: "https://open.spotify.com/artist/5Pir3nnrulz7WMyC9bFhkL?si=AChTkclsTeWfAsMY4yCrCg",
    img: "deary.jpeg",
  },
  {
    name: "DU BLONDE",
    sort: "DU BLONDE",
    link: "https://open.spotify.com/artist/46MOKAqmDsUILZl3iXyPmw?si=2OiN_PZaQ2aR60AEEQ6WWA",
    img: "dublond.jpg",
  },
  {
    name: "DO NOTHING",
    sort: "DO NOTHING",
    link: "https://donothingband.com/",
    img: "donothing.jpg",
  },
  {
    name: "FAMOUS",
    sort: "FAMOUS",
    link: "https://open.spotify.com/artist/76pvNo3GAo5aeXBZ4jVz0k?si=2HiuD2HtSju5pFy4GTEMLw",
    img: "famous.jpeg",
  },
  {
    name: "Gong",
    sort: "Gong",
    link: "https://www.gongband.com/",
    img: "gong.jpg",
  },
  {
    name: "GHOST CAR",
    sort: "GHOST CAR",
    link: "https://open.spotify.com/artist/0JjQ9wolkyDHtnCGE5G84G?si=-5-qbYANSOeSU0TOR6TgkA",
    img: "ghostcar.jpg",
  },
  {
    name: "KARMA SHEEN",
    sort: "KARMA SHEEN",
    link: "https://open.spotify.com/artist/5jKjC91GYS58L8hhnDiC4j?si=JUyxAl-NQ-uBmIqY_oEB7w",
    img: "karmasheen.jpg",
  },
  {
    name: "Le Sécurité",
    sort: "Le Sécurité",
    link: "https://open.spotify.com/artist/5ijO3JnnKpoAOTU4QaDgdW?si=0m5fOmJaQFydIjvXrzLUnw",
    img: "lesec.jpg",
  },
  {
    name: "NADINE SHAH",
    sort: "NADINE SHAH",
    link: "https://nadineshah.co.uk/",
    img: "nadinesha.jpg",
  },
  {
    name: "PLUS44KALIGULA",
    sort: "PLUS44KALIGULA",
    link: "https://www.instagram.com/plus44kaligula/",
    img: "plus44.jpg",
  },
  {
    name: "RABBITFOOT",
    sort: "RABBITFOOT",
    link: "https://www.instagram.com/rabbitfoottheband/",
    img: "rabbitfoot.webp",
  },
  {
    name: "THE SICK MAN OF EUROPE",
    sort: "SICK MAN OF EUROPE",
    link: "https://www.instagram.com/thesickmanofeurope_/",
    img: "slickman.jpg",
  },
  {
    name: "TROPICAL FUCK STORM",
    sort: "TROPICAL FUCK STORM",
    link: "https://open.spotify.com/artist/0mL6LBSQ4bHe6hWq90KzHL",
    img: "tropicalfuck.jpeg",
  },
  {
    name: "WESTSIDE COWBOY",
    sort: "WESTSIDE COWBOY",
    link: "https://open.spotify.com/artist/5LfO4rbJarBvHjB34mU9m2?si=77PueSzFSne4WE0utiRwew",
    img: "westside.jpg",
  },
  {
    name: "W. H. LUNG",
    sort: "W. H. LUNG",
    link: "https://www.whlungmusic.com/",
    img: "whlung.jpg",
  },

  {
    name: "The Bug Club",
    sort: "Bug Club",
    link: "https://open.spotify.com/artist/7eiTMbuHYUPjrAMjIhAVDB?si=jXoDoWuBSTiLaF1B_0xAzQ",
    img: "bugclub.jpg",
  },
  {
    name: "Christopher Owens",
    sort: "Christopher Owens",
    link: "https://open.spotify.com/artist/0ukgSx1gUt5rUihbNh46qy",
    img: "chrisowens.jpeg",
  },
  {
    name: "Cryogeyser",
    sort: "Cryogeyser",
    link: "https://cryogeyser.com/",
    img: "cryogeyser.jpg",
  },
  {
    name: "Dove Ellis",
    sort: "Dove Ellis",
    link: "https://www.instagram.com/doveellis_/",
    img: "doveellis.jpg",
  },
  {
    name: "Dutch Interior",
    sort: "Dutch Interior",
    link: "https://open.spotify.com/artist/7a0nCvxmDN4c68agh8ajMn?si=-Fp09wrYTgGlYFZXNxgIfg",
    img: "ducthint.jpeg",
  },
  {
    name: "Floodlights",
    sort: "Floodlights",
    link: "https://floodlightsband.com/",
    img: "floodlights.jpg",
  },
  {
    name: "Getdown Services",
    sort: "Getdown Services",
    link: "https://open.spotify.com/artist/4OTD2AbOu5iBqSWk3NfwG5?si=PKEOmeD6Toyp-hyqoUQtVQ",
    img: "getdownservices.jpg",
  },
  {
    name: "Horse Jumper of Love",
    sort: "Horse Jumper of Love",
    link: "https://horsejumperoflove.com/#home-section",
    img: "horsejumper.jpg",
  },
  {
    name: "Joshua Idehen",
    sort: "Joshua Idehen",
    link: "https://open.spotify.com/artist/3PubLnxnO5N2Avr3UvG1Vc?si=rVu2863RQPWYWtllJ3HlJQ",
    img: "josh.jpeg",
  },
  {
    name: "LSD and the Search for God",
    sort: "LSD and the Search for God",
    link: "https://open.spotify.com/artist/2feOOr1Yjovo67byuxvjZv",
    img: "lsdand.png",
  },
  {
    name: "Mandrake Handshake",
    sort: "Mandrake Handshake",
    link: "https://open.spotify.com/artist/3tW2ocpP6a9HqZoWgn45kn?si=SFBB4xpGTuiXsPJSn4At9w",
    img: "mandrake.jpg",
  },
  {
    name: "The Orchestra (For Now)",
    sort: "Orchestra (For Now)",
    link: "https://open.spotify.com/artist/4M1DlOtwciPLmjRWBWOpFG?si=P95044pAStio7uyOYQY37Q",
    img: "theorch.jpg",
  },
  {
    name: "Sex Week",
    sort: "Sex Week",
    link: "https://open.spotify.com/artist/5bcg41eahXhsa30vaMvv0r",
    img: "sexweek.jpeg",
  },
  {
    name: "Silverwingkiller",
    sort: "Silverwingkiller",
    link: "https://www.instagram.com/slvrwngkllr/?hl=en",
    img: "silverringkiller.jpeg",
  },
  {
    name: "Skloss",
    sort: "Skloss",
    link: "https://www.sklossduo.com/",
    img: "skloss.jpg",
  },
  {
    name: "Slow Fiction",
    sort: "Slow Fiction",
    link: "https://slowfictionband.com/",
    img: "slowfiction.png",
  },
  {
    name: "The Telescopes",
    sort: "Telescopes",
    link: "https://open.spotify.com/artist/5MTQzge85m3QSefD2LdS1J?si=MxDh5IOiSHKMPJUY9F_KOQ",
    img: "thetele.jpeg",
  },
  {
    name: "Warmduscher",
    sort: "Warmduscher",
    link: "https://open.spotify.com/artist/1CWwXncu9sk7EIdbvqcquR",
    img: "warmd.jpg",
  },
  {
    name: "Woioi",
    sort: "Woioi",
    link: "https://open.spotify.com/artist/4tOkbI0vH6BdfnK5uhaGzR",
    img: "woioi.jpg",
  },
  {
    name: "Y",
    sort: "Y",
    link: "https://open.spotify.com/artist/3Lj9IhE3QFZJo2N2RcQ7Ih?si=PrhZtBrwSsmmG199hR6kjw",
    img: "y.jpg",
  },
  {
    name: "Yellow Days",
    sort: "Yellow Days",
    link: "https://open.spotify.com/artist/3dv4Q4q3LWOnbLJnC6GgTY?si=2Q7x5AtSRdO8CcfT5f4S7A",
    img: "yellowdays.jpg",
  },
  {
    name: "Yīn Yīn",
    sort: "Yīn Yīn",
    link: "https://open.spotify.com/artist/2sLMYvxNmHIYNx6re1WUM2",
    img: "yinyin.jpg",
  },
  {
    name: "Cowboy Hunters",
    sort: "Cowboy Hunters",
    link: "https://open.spotify.com/artist/5GSSYBJxAbpSyj2w2vr5Cp?si=kENAfh0gQJa27ys5bScfIA",
    img: "cowboy.jpg",
  },
  {
    name: "Dead Stilettos",
    sort: "Dead Stilettos",
    link: "https://open.spotify.com/artist/6KGeS9on2ykpqmQh3L7t7y?si=whAh1YpjTSmcgnXLk31cwQ",
    img: "deadsti.jpg",
  },
  {
    name: "Formal Sppeedwear",
    sort: "Formal Sppeedwear",
    link: "https://open.spotify.com/artist/6jGvuyheUzkEjJLHJopDuu?si=uPpTxelsTqGiaP9wEVHgDQ",
    img: "formal.jpg",
  },
  {
    name: "Full Flower Moon Band",
    sort: "Full Flower Moon Band",
    link: "https://open.spotify.com/artist/29YPQKsmJN2L0YVz7HaOi4?si=h0T0sbqkQ86CL6H4JKu2IQ",
    img: "fullflower.png",
  },
  {
    name: "Jeanie and the White Boys",
    sort: "Jeanie and the White Boys",
    link: "https://open.spotify.com/artist/0ebWEKLuFzYXaiMiSnGX6K?si=J24q5KQZSSCmWqlPM0UoyA",
    img: "jeanie.jpg",
  },
  {
    name: "The Moonlandingz",
    sort: "Moonlandingz",
    link: "https://shop.themoonlandingz.com/",
    img: "moonland.jpg",
  },
  {
    name: "Pale Blue Eyes",
    sort: "Pale Blue Eyes",
    link: "https://www.paleblueeyes.co.uk/",
    img: "pale.jpg",
  },
  {
    name: "With Magazine",
    sort: "With Magazine",
    link: "https://open.spotify.com/artist/2M96WtsZj9j1qAz4UubJDm?si=03P2xGwoTmqyKLdf6_HL8w",
    img: "withmag.jpg",
  },
  {
    name: "Yaang",
    sort: "Yaang",
    link: "https://open.spotify.com/artist/35CNODI0rTcPk946a2fXP0?si=8qitB1SvTied9QgO9VCG5g",
    img: "yaang.jpg",
  },
  {
    name: "YOBS",
    sort: "YOBS",
    link: "https://open.spotify.com/artist/1kfpcRPiUVWVLldtIeh1IH?si=aJ3s8NlCQL6vDVM327JAWw",
    img: "yobs.jpg",
  },

  {
    name: "Big Swig",
    sort: "big swig",
    link: "https://www.instagram.com/bigswigmusic",
    img: "bigswig.jpeg",
  },
  {
    name: "C.O.F.F.I.N",
    sort: "coffin",
    link: "https://www.coffinband.com",
    img: "coffin.JPG",
  },
  {
    name: "Goodbye",
    sort: "goodbye",
    link: "https://www.instagram.com/goodbye.band/",
    img: "goodbye.jpg",
  },
  {
    name: "Green Star",
    sort: "green star",
    link: "https://open.spotify.com/artist/35CQyx6pBd8bt19LYBmVOe?si=VFCiJjmZQlmAYPRUtzxoAA",
    img: "greenstar.jpeg",
  },
  {
    name: "Jadu Heart",
    sort: "jadu heart",
    link: "https://www.jaduheart.com/",
    img: "jaduheart.jpg",
  },
  {
    name: "Lana Death Ray",
    sort: "lana death ray",
    link: "https://open.spotify.com/artist/45UxG0WwmhtDyFZHhbnsxu?si=ksNYHsMVQZenRFswNsEZDg",
    img: "lanadeathray.jpeg",
  },
  {
    name: "Makeshift Art Bar",
    sort: "makeshift art bar",
    link: "https://open.spotify.com/artist/64eXjwiYuMUVSpJ3pP6FNH?si=kY1yi4EMSxeZ2sMwGUE51g",
    img: "makeshiftartbar.jpg",
  },
  {
    name: "Puppy Teeth",
    sort: "puppy teeth",
    link: "https://open.spotify.com/artist/3Aa4gouX2gZ66QQ1LdcLzt?si=d_6sUO4AT6WZkyrqNReCnA",
    img: "puppyteeth.jpg",
  },
  {
    name: "Radio Free Alice",
    sort: "radio free alice",
    link: "https://www.rfa.band/",
    img: "radiofree.jpg",
  },
  {
    name: "Sydney Minsky Sargeant",
    sort: "sydney minsky sargeant",
    link: "https://www.instagram.com/sydminskysargeant/?hl=en",
    img: "sydneyminskysargeant.jpg",
  },
  {
    name: "Theatre",
    sort: "theatre",
    link: "https://www.instagram.com/theatre.band/?hl=en",
    img: "theatre.png",
  },
  {
    name: "Twin Flames",
    sort: "twin flames",
    link: "https://www.instagram.com/twinflamesbanduk",
    img: "twinflames.jpeg",
  },
  {
    name: "Wyatt",
    sort: "wyatt",
    link: "https://www.instagram.com/wyatt__band/?hl=en",
    img: "wyatt.jpeg",
  },
  {
    name: "Zo Lief",
    sort: "zo lief",
    link: "https://open.spotify.com/artist/655lv153aeepabVfhjnGwq?si=DCABtRCuTrKm968GlbtK7w",
    img: "zolief.png",
  },
];

const sortedArtists = artists.sort((a, b) => a.sort.localeCompare(b.sort));

function LineUp() {
  return (
    <Container className="LineUp" maxWidth="xl">
      <Box sx={{ flexGrow: 1, flexWrap: "wrap", display: { xs: "flex" } }}>
        {sortedArtists.map((artist) => (
          <LineUpCard key={artist.name} artist={artist} />
        ))}
      </Box>
    </Container>
  );
}
export default LineUp;
